import { LUXE_BY_TTAND_BRAND, TTAND_BRAND } from "@/types/constants/common";

const isTtandBranded = (brandedAs?: string | null): boolean =>
  brandedAs === TTAND_BRAND || brandedAs === LUXE_BY_TTAND_BRAND;

export default isTtandBranded;
